/* Bonst cart upsell: inline card + one-time popup on /cart, and an offer inside Dawn's add-to-cart popup. */
(function () {
  if (window.__bonstUpsell) return;
  window.__bonstUpsell = true;

  var el = document.querySelector('script[data-bonst-upsell]');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  if (!cfg.offers || !cfg.offers.length) return;
  cfg.offers.forEach(function (o) {
    if (o.onlyVariant) o.variants = o.variants.filter(function (v) { return v.id === o.onlyVariant; });
  });

  function formatMoney(cents) {
    cents = Math.round(cents);
    var fmt = cfg.moneyFormat || '{{amount}} kr';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var comma = m && /comma|space/.test(m[1]);
    var noDec = m && /no_decimals/.test(m[1]);
    var parts = (cents / 100).toFixed(noDec ? 0 : 2).split('.');
    var th = m && /space/.test(m[1]) ? ' ' : comma ? '.' : ',';
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
    var v = parts[1] && !/^0+$/.test(parts[1]) ? parts[0] + (comma ? ',' : '.') + parts[1] : parts[0];
    return m ? fmt.replace(m[0], v) : v;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function getCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function eligible(cart) {
    var ids = cart.items.map(function (i) { return i.product_id; });
    if (ids.indexOf(cfg.trigger) === -1) return [];
    return cfg.offers.filter(function (o) {
      return ids.indexOf(o.productId) === -1 && o.variants.some(function (v) { return v.available; });
    });
  }

  function offerHTML(o) {
    var vs = o.variants.filter(function (v) { return v.available; });
    var v = vs[0];
    var now = Math.round(v.price * (1 - o.pct / 100));
    var select = vs.length > 1
      ? '<select class="bonst-up__select" aria-label="Velg variant">' + vs.map(function (x) { return '<option value="' + x.id + '">' + esc(x.title) + '</option>'; }).join('') + '</select>'
      : '<input type="hidden" class="bonst-up__select" value="' + v.id + '">';
    return '<li class="bonst-up__item" data-discounted="' + (o.pct > 0 ? '1' : '0') + '">' +
      (o.image ? '<a href="' + esc(o.url) + '" class="bonst-up__media"><img src="' + esc(o.image) + '" alt="" loading="lazy" width="120" height="120"></a>' : '') +
      '<div class="bonst-up__info">' +
        '<a href="' + esc(o.url) + '" class="bonst-up__title">' + esc(o.title) + (o.onlyVariant && v.title && v.title !== 'Default Title' ? ' · ' + esc(v.title) : '') + '</a>' +
        '<span class="bonst-up__price"><b>' + formatMoney(now) + '</b>' + (o.pct > 0 ? ' <s>' + formatMoney(v.price) + '</s> <em>-' + String(o.pct).replace('.', ',') + ' %</em>' : '') + '</span>' +
        select +
      '</div>' +
      '<button type="button" class="bonst-up__add" aria-label="Legg til ' + esc(o.title) + ' i handlekurven"><span class="visually-hidden">Legg til</span></button>' +
    '</li>';
  }
  function blockHTML(offers, compact) {
    return '<div class="bonst-up' + (compact ? ' bonst-up--compact' : '') + '">' +
      '<p class="bonst-up__heading">' + esc(cfg.heading) + '</p>' +
      (cfg.text ? '<p class="bonst-up__text">' + esc(cfg.text) + '</p>' : '') +
      '<ul class="bonst-up__list" role="list">' + offers.map(offerHTML).join('') + '</ul>' +
    '</div>';
  }

  function refreshBubble() {
    return fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = s && s['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (!html || !target) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.shopify-section');
        if (src) target.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function wire(root, onAdded) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.bonst-up__add');
      if (!btn) return;
      var item = btn.closest('.bonst-up__item');
      var id = parseInt(item.querySelector('.bonst-up__select').value, 10);
      var line = { id: id, quantity: 1 };
      if (cfg.appstle && item.dataset.discounted === '1') {
        line.properties = { '__appstle-bb-name': cfg.appstle.name, '_appstle-bb-id': cfg.appstle.id, '_appstle_bundles_type': 'VOLUME_DISCOUNT' };
      }
      btn.disabled = true;
      btn.classList.add('loading');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [line] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.classList.remove('loading');
          if (res.status) { btn.disabled = false; btn.setAttribute('aria-label', 'Prøv igjen'); return; }
          btn.classList.add('is-added');
          btn.setAttribute('aria-label', 'Lagt til i handlekurven');
          onAdded && onAdded(item);
        })
        .catch(function () { btn.disabled = false; btn.classList.remove('loading'); });
    });
  }

  /* ---------- cart page ---------- */
  if (cfg.mode === 'page') {
    var inline = document.querySelector('[data-bonst-upsell-inline]');
    getCart().then(function (cart) {
      var offers = eligible(cart);
      if (!offers.length) return;
      if (inline) {
        inline.innerHTML = blockHTML(offers, false);
        wire(inline, function () { setTimeout(function () { window.location.reload(); }, 400); });
      }
      var seen = false;
      try { seen = sessionStorage.getItem('bonst-upsell-seen') === '1'; } catch (e) {}
      if (seen) return;
      try { sessionStorage.setItem('bonst-upsell-seen', '1'); } catch (e) {}
      setTimeout(function () { openModal(offers); }, 700);
    });
  }

  function openModal(offers) {
    var wrap = document.createElement('div');
    wrap.className = 'bonst-up-modal';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', cfg.heading);
    wrap.innerHTML = '<div class="bonst-up-modal__backdrop" data-close></div>' +
      '<div class="bonst-up-modal__panel color-scheme-1">' +
        '<button type="button" class="bonst-up-modal__close" aria-label="Lukk" data-close>&times;</button>' +
        blockHTML(offers, false) +
        '<button type="button" class="bonst-up-modal__skip link" data-close>Nei takk, gå til handlekurven</button>' +
      '</div>';
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    var close = function () {
      wrap.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { wrap.remove(); }, 250);
    };
    var onKey = function (e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);
    wrap.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    wire(wrap, function () { setTimeout(function () { window.location.reload(); }, 400); });
    var first = wrap.querySelector('.bonst-up__add');
    if (first) first.focus({ preventScroll: true });
  }

  /* ---------- add-to-cart popup (Dawn cart notification) ---------- */
  function injectIntoNotification() {
    var host = document.getElementById('cart-notification');
    if (!host) return;
    getCart().then(function (cart) {
      var old = host.querySelector('.bonst-up-notify');
      if (old) old.remove();
      var offers = eligible(cart);
      if (!offers.length) return;
      var box = document.createElement('div');
      box.className = 'bonst-up-notify';
      box.innerHTML = blockHTML(offers, true);
      var links = host.querySelector('.cart-notification__links');
      host.insertBefore(box, links || null);
      wire(box, function (item) {
        refreshBubble();
        setTimeout(function () { item.classList.add('is-added'); }, 200);
      });
    });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && evt.source === 'product-form') setTimeout(injectIntoNotification, 60);
    });
  }
})();